<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img src="../assets/img/7.jpg" class="img-avatar"/>
    </template>
    <template slot="dropdown">
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'UserSettingsDropdown',
  methods: {
    logout () {
      this.$loading.show()
      this.$store.dispatch('logout', {root: true})
        .then(status => {
          if (status === 200) {
            this.$router.push('/login')
          }
          this.$loading.hide()
        })
    }
  },
  components: {
    AppHeaderDropdown
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserSettingsDropdown.vue